if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        var additionalVariantId = null;
        var customizatitonType = "Custom";
        var customizatitonValue = "Custom";
        var isBlousePadidng = false;
        var quantity = 1;
        var properties = {};

        //link
        var s_id = document.querySelector('#s_id') ? document.querySelector('#s_id').value : null;

        //price points
        var standard_blouseStyle = document.querySelector('.standard select[name="properties[Blouse Padding]"]:not([disabled])')?document.querySelector('.standard select[name="properties[Blouse Padding]"]:not([disabled])').value:null ;
        var custom_blouseStyle = document.querySelector('.custom select[name="properties[Blouse Padding]"]:not([disabled])')?document.querySelector('.custom select[name="properties[Blouse Padding]"]:not([disabled])').value:null ;
        var plusSize = document.querySelector('.custom select[name="properties[Around Bust]"]:not([disabled])')?document.querySelector('.custom select[name="properties[Around Bust]"]:not([disabled])').value:null ;
        var kidsPlusSize = document.querySelector('.kidswear select[name="properties[Stitching Type]"]:not([disabled])')?document.querySelector('.kidswear select[name="properties[Stitching Type]"]:not([disabled])').value:null ;

        //Only Standatd Blouse Padding
        if(standard_blouseStyle != null && standard_blouseStyle != "Without Blouse Padding") { 
          isBlousePadidng = true;
          additionalVariantId = '41104985325650';
          //customizatitonType = "Blouse Padding";  
          //customizatitonValue = standard_blouseStyle;  
          
        }
        properties[customizatitonType] = customizatitonValue;

        //Only Custom Blouse Padding
        if(custom_blouseStyle != null && custom_blouseStyle != "Without Blouse Padding") {
          isBlousePadidng = true;
          additionalVariantId = '41104985325650';
          //customizatitonType = "Blouse Padding";  
          //customizatitonValue = standard_blouseStyle;  
        }
        properties[customizatitonType] = custom_blouseStyle;

        //Only Plus Size
        if(plusSize != null && isBlousePadidng == false ) {

          switch (plusSize) {
            case 'Size 43':
                additionalVariantId = '41104985358418';
                break;
            case 'Size 44':
                additionalVariantId = '41104985391186';
                break;
            case 'Size 45':
                additionalVariantId = '41104985423954';
                break;
            case 'Size 46':
                additionalVariantId = '41104985456722';
                break;
            case 'Size 47':
                additionalVariantId = '41104985489490';
                break;
            case 'Size 48':
                additionalVariantId = '41104985522258';
                break;
            default:
                break;
          }
          customizatitonType = "";  
          customizatitonValue = "";  
        }

        //Bouse Padding and Plus Size
        if(plusSize != null && isBlousePadidng == true ) {
          switch (plusSize) {
            case 'Size 43':
                additionalVariantId = '41108241645650';
                break;
            case 'Size 44':
                additionalVariantId = '41108241678418';
                break;
            case 'Size 45':
                additionalVariantId = '41108241711186';
                break;
            case 'Size 46':
                additionalVariantId = '41108241743954';
                break;
            case 'Size 47':
                additionalVariantId = '41108241776722';
                break;
            case 'Size 48':
                additionalVariantId = '41108241809490';
                break;
            default:
                break;
          }
          customizatitonType = "";  
          customizatitonValue = "";  
        }
        //properties[customizatitonType] = customizatitonValue;

        //Only Kids Plus Size
        if(kidsPlusSize != null) {

          switch (kidsPlusSize) {
            case '7 Yrs':
                additionalVariantId = '41134356627538';
                break;
            case '8 Yrs':
                additionalVariantId = '41134356660306';
                break;
            case '9 Yrs':
                additionalVariantId = '41134356693074';
                break;
            case '10 Yrs':
                additionalVariantId = '41134356725842';
                break;
            case '11 Yrs':
                additionalVariantId = '41134356758610';
                break;
            case '12 Yrs':
                additionalVariantId = '41134356791378';
                break;
            default:
                break;
          }
          customizatitonType = "";  
          customizatitonValue = "";  
        }
        
        properties['_s_id'] = s_id;
       // alert(s_id);
        
      

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;


            if(additionalVariantId != null && properties != null){
              addToCart(additionalVariantId, quantity, properties);
            }

            function addToCart(variantId, quantity,properties) {
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: variantId,
                                quantity: quantity,
                                properties: properties || {}
                            }
                        ]
                    })
                }).then(response => {
                 setTimeout(() => { 
                  document.getElementById("s_id").value = "bn_"+Date.now();
                  //alert("ok");
                   }, 4000);
                  
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                });
            }

        
  setTimeout(() => { 
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              /*publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });*/
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                    this.cart.renderContents(response);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

          });
          
}, 5000);

        
       
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
